import { Route, Switch } from 'react-router-dom'
import { ActiveOverlayContextProvider } from '../../../Components/shared/Routing/OverlayContext'
import Digest from './Digest'
import { NewHome } from './NewHome'

// This file is a placeholder for any expansion of homeowner routes
const HomeownerRoutes = ({ match }) => (
  <ActiveOverlayContextProvider>
    <Switch>
      <Route path={`${match.url}/new`} component={NewHome} />
      <Route path={`${match.url}/:homeId([0-9A-Fa-f]{24})`} component={Digest} />
    </Switch>
  </ActiveOverlayContextProvider>
)

export default HomeownerRoutes
